import BillingsOrderForwardRelatedCargoTaxiResponse, {
  BillingsOrderForwardRelatedCargoTaxiResponseData,
  BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus,
  BillingsOrderForwardRelatedCargoTaxiResponseDataContract,
  BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel,
} from "../../../../../api/raily/billings/order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi.response";
import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";
import BillingsOrderForwardRelatedCargoTaxi, {
  BillingsOrderForwardRelatedCargoTaxiItem,
  BillingsOrderForwardRelatedCargoTaxiItemContractDetails,
} from "./billings-order-forward-related-cargo-taxi";

const createDataItemStatus = (
  status: BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus,
): BillingStatus => {
  switch (status) {
    case BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus.CREATED:
      return BillingStatus.CREATED;
    case BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus.ACCEPTED:
      return BillingStatus.ACCEPTED;
    case BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus.REJECTED:
      return BillingStatus.REJECTED;
    case BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus.REOPEN_REQUEST:
      return BillingStatus.REOPEN_REQUEST;
    case BillingsOrderForwardRelatedCargoTaxiResponseDataBillingStatus.REOPENED:
      return BillingStatus.REOPENED;
  }
};

const createDataItemBillingModel = (
  billingModel: BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderForwardRelatedCargoTaxiResponseDataContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItemContractDetails = (
  contractDetails: BillingsOrderForwardRelatedCargoTaxiResponseDataContract,
): BillingsOrderForwardRelatedCargoTaxiItemContractDetails => {
  return {
    companyName: contractDetails.cargoCompany.displayName,
    distanceRate: contractDetails.distanceRate,
    model: createDataItemBillingModel(contractDetails.model),
  };
};

const createDataItem = (
  data: BillingsOrderForwardRelatedCargoTaxiResponseData,
): BillingsOrderForwardRelatedCargoTaxiItem => {
  return {
    billingUuid: data.id,
    cargoOrderUuid: data.cargoOrder.id,
    contractDetails: createDataItemContractDetails(data.contract),
    amountForDistance: data.amountForDistance,
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    distance: data.distance,
    internalOrderId: data.cargoOrder.humanId,
    contractCorrectionPercentage: data.contractCorrectionPercentage,
    allContributionsAmount: data.allContributionsAmount,
    sumOfDiscounts: data.sumOfDiscounts,
    isDraft: data.draft,
    date: data.date,
    status: createDataItemStatus(data.status),
  };
};

const createData = (
  responseData: BillingsOrderForwardRelatedCargoTaxiResponseData[],
): BillingsOrderForwardRelatedCargoTaxiItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: BillingsOrderForwardRelatedCargoTaxiResponse,
): BillingsOrderForwardRelatedCargoTaxi => {
  return {
    data: createData(response.data),
  };
};

const billingsOrderForwardRelatedCargoTaxiFactory = {
  create,
};

export default billingsOrderForwardRelatedCargoTaxiFactory;
